module.exports = __webpack_public_path__ + "static/img/AdelaideThunderbirds.1988248.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/AdelaideThunderbirds.png
// module id = MyKw
// module chunks = 1